<template>
  <div class="text-black tab-pane active" id="dtab1" role="tabpanel">
    <div class="row">
      <div class="col-md-7 col-lg-7 col-xl-8 f1 text-black">
        <div class="heading mb-2">
          <h4 class="text-black">
            <strong>Daten</strong>
          </h4>
        </div>
        <div class="tblock pt-2">
          <h5 class="font-weight-bold">Titel</h5>
          <div class="iblock pt-1">
            <div class="heading  p-2 border">
              <span class="font14">{{task.flawname}}</span>
            </div>
          </div>
        </div>
        <div class="tblock pt-3">
          <h5 class="font-weight-bold">Beschreibung</h5>
          <div class="iblock mt-1">
            <p class="p-2 border description font14">
              {{task.description}}
            </p>
          </div>
        </div>
        <div class="tblock pt-3">
          <h5 class="font-weight-bold mb-1">Zusatzfelder</h5>
          <div class="row m-0 pt-1" v-for="(param, x) in task.flawparams" :key="x" v-if="param.paramvalue">
            <div class="col-md-5 pl-0 pr-2">
              <input class="input-style form-control font12 bg-light" :value="param.paramtitle" disabled>
            </div>
            <div class="col-md-7 p-0">
              <input class="input-style form-control font12 bg-light" :value="param.paramvalue" disabled>
            </div>
          </div>
        </div>

      <!-- Photos Tab  -->
        <photos-tab :flawitems="task.flawitems"/>
      <!--  plans tab -->
        <plan-tab :showPlan="showPlan" :task="task" />

      </div>
      <div class="col-md-5 col-lg-5 col-xl-4  border-left text-black border-dark f2">
        <div class="tblock mb-2">
          <span class="btn btn-success text-capitalize rounded-0" v-if="task.status === 0">Erledigt</span>
          <span class="btn btn-warning text-capitalize rounded-0" v-if="task.status === 1">Prüfen</span>
          <span class="btn btn-danger rounded-0" v-if="task.status === 2">Offen</span>
        </div>

        <div class="tblock pt-2">
          <h5 class="font-weight-bold">Art</h5>
           <span> {{task.flawtype === 1 ? 'Mangel': 'Restleistung'}} </span>
        </div>

        <div class="tblock pt-3">
          <h5 class="font-weight-bold">Gewerk </h5>

          <ul class="list-group-flush mr-2 mt-1">
            <li v-for="trd in task.selectedtrades" class="list-group-item pt-1 pb-1 pl-0 pr-2 border-bottom">
              {{ getService(trd.pdserviceid).pdservicetitle }}
              <span v-if="getService(trd.pdserviceid).company"> ( {{ getService(trd.pdserviceid).company }} )</span>
            </li>
          </ul>
          <p v-if="task.selectedtrades.length < 1"> --  </p>
        </div>

        <div class="tblock user pt-3">
          <h5 class="mb-2 font-weight-bold">Verantwortlicher</h5>
            <p>
              <img src="@/assets/images/user.png" class="img-fluid rounded-circle" alt="userIng" width="40">
              <span class="pl-2">
                  {{ user(task.responsibleuser) ? `${user(task.responsibleuser).firstname} ${user(task.responsibleuser).lastname}` : ''}}
                </span>
            </p>
        </div>

        <div class="tblock text-black pt-3">
          <h5 class="font-weight-bold">Festgestellt am</h5>
          <p class="mt-1">
            <span class="date">{{setDate(task.noticedate)}}</span>
          </p>
        </div>

        <div class="tblock text-black pt-3">
          <h5 class="font-weight-bold">Angezeigt am</h5>
          <p class="mt-1">{{ setDate(task.notifiedate) ? setDate(task.notifiedate) : '--' }}</p>
        </div>
        <div class="tblock text-black pt-3">
          <h5 class="font-weight-bold">Frist</h5>
          <p class="mt-1">{{ setDate(task.fristdate) ? setDate(task.fristdate): '--' }}</p>
        </div>
        <div class="tblock text-black pt-3">
          <h5 class="font-weight-bold">Erledigt am</h5>
          <p class="mt-1">{{ setDate(task.donedate) ? setDate(task.donedate) : '--' }}</p>
        </div>
        <div class="tblock  text-black pt-3 user">
          <h5 class="font-weight-bold">Ersteller</h5>
          <p><img class="pr-2 pt-2" src="@/assets/images/user.png" alt="logo" width="50">
            {{ task.creator }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {formatDate} from '../../common'
import PhotosTab from './PhotosTab'
import PlanTab from './PlanTab'
import {mapState} from 'vuex'
export default {
  props: ['showPlan'],
  data(){
    return {
      trade: {}
    }
  },
  components: { PhotosTab , PlanTab},
  computed: {
    ...mapState({
      services: state => state.tasks.servicesWithCompanies,
      task: state => state.tasks.taskDetails,
      projectUsers: state => state.appSettings.projectUsers,
    }),
  },
  methods: {
    user (id) {
      return this.projectUsers.find(item => id === item.pduserid)
    },
    setDate(date){
      return formatDate(date)
    },
    getUser(id){
      this.projectUsers.find(user => user.pduserid === id)
    },
    getService (service_id) {
      let id = service_id.split('-');
      return this.services.find(item => item.pdserviceid === parseInt(id[0]))
    }
  }
}
</script>
<style scoped>
.tblock .iblock .description{
 min-height: 5.4rem;
 padding-top: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/tasks/preview-tabs/DetailsTab.vue